<div class="row">
    <div class="col-sm-8 col-12">
        <h1>Consulta Aditivo da PAC<span *ngIf="aditivo"> {{aditivo?.propostaNumero}} / {{aditivo?.propostaAno}}</span>
        </h1>
    </div>
    <!-- div class="col-sm-4 col-12 d-flex align-items-end">
        <h5><a routerLink="//envio-aditivo/{{aditivo?.idPacAditada}}">PAC Aditada: {{aditivo?.idPacAditada}}</a></h5>
    </div -->
</div>

<h5>Dados Gerais</h5>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">PAC Aditada</h6>
                <p><a routerLink="//envio-aditivo/{{aditivo?.idPacAditada}}">{{aditivo?.idPacAditada}}</a></p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Protocolo Aditivo</h6>
                <p>{{aditivo?.datProtocolo | date: 'dd/MM/yyyy'}}</p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Situação</h6>
                <p>{{aditivo?.situacaoNomeExterno}}</p>
            </div>
        </div>
    </div>
</div>

<h5>Dados da Beneficiária</h5>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNPJ / CPF</h6>
                <p>{{aditivo?.compradorCnpjCpf | bnMask: 'CNPJCPF'}}</p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Razão Social</h6>
                <p>{{aditivo?.compradorNome}}</p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNAE</h6>
                <p *ngIf="aditivo?.compradorCnae">{{aditivo?.compradorCnaeIdNome}}</p>
                <p *ngIf="!aditivo?.compradorCnae">Não Informado</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">ROB Beneficiária</h6>
                <p>R$ {{aditivo?.compradorRobValor | bnMask: 'MOEDA'}}<br/>
                    <small>{{aditivo?.compradorRobValor | bnValorPorExtenso : 'monetario' : 'BRL'}}</small></p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Data de Referência</h6>
                <p>{{aditivo?.compradorRobData | date: 'dd/MM/yyyy'}}</p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Tipo de Renda</h6>
                <p>{{aditivo?.compradorRobTipoNome}}</p>
            </div>
        </div>

        <div *ngIf="aditivo?.grupoCnpjLider && aditivo?.grupoRobTipo">
            <div class="row" *ngIf="aditivo?.grupoRobTipo">
                <div class="col-sm-4 col-12">
                    <h6 class="mb-0">ROB do Grupo Econômico</h6>
                    <p>R$ {{aditivo?.grupoRobValor | bnMask: 'MOEDA'}}<br/>
                        <small>{{aditivo?.grupoRobValor | bnValorPorExtenso : 'monetario' : 'BRL'}}</small></p>
                </div>
                <div class="col-sm-4 col-12">
                    <h6 class="mb-0">Data de Referência</h6>
                    <p>{{aditivo?.grupoRobData | date: 'dd/MM/yyyy'}}</p>
                </div>
                <div class="col-sm-4 col-12">
                    <h6 class="mb-0">Tipo de Renda</h6>
                    <p>{{aditivo?.grupoRobTipoNome}}</p>
                </div>
            </div>
            <div class="row" *ngIf="aditivo?.grupoCnpjLider">
                <div class="col-sm-4 col-12">
                    <h6 class="mb-0">CNPJ Líder Grupo</h6>
                    <p>{{aditivo?.grupoCnpjLider | bnMask: 'CNPJ'}}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Porte</h6>
                <p>{{aditivo?.compradorPorteNome}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8 col-12">
                <h6 class="mb-0">Caracterização do Capital Social</h6>
                <p *ngIf="aditivo?.compradorCapitalSocialNome">{{aditivo?.compradorCapitalSocialNome}}</p>
                <p *ngIf="!aditivo?.compradorCapitalSocialNome">Não Informado</p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Atividade Decreto 2.333/1997</h6>
                <p *ngIf="aditivo?.compradorIndAtividadeDecreto">{{aditivo?.compradorIndAtividadeDecreto}}</p>
                <p *ngIf="!aditivo?.compradorIndAtividadeDecreto">Não Informado</p>
            </div>
        </div>
    </div>
</div>

<h5>Dados do Investimento</h5>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNPJ Investimento</h6>
                <p *ngIf="aditivo?.investimentoCnpj">{{aditivo?.investimentoCnpj | bnMask: 'CNPJ'}}</p>
                <p *ngIf="!aditivo?.investimentoCnpj">Não Informado</p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNAE Investimento</h6>
                <p *ngIf="aditivo?.investimentoCnae">{{aditivo?.investimentoCnaeIdNome}}</p>
                <p *ngIf="!aditivo?.investimentoCnae">Não Informado</p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Município de Instalação</h6>
                <p *ngIf="aditivo?.municipioInstalNome">{{aditivo?.municipioInstalNomeUf}}</p>
                <p *ngIf="!aditivo?.municipioInstalNome">Não Informado</p>
            </div>
        </div>
    </div>
</div>

<h5>Comentário</h5>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <p>{{aditivo?.comentario}}</p>
            </div>
        </div>
    </div>
</div>

<span *ngIf="aditivo?.situacaoId == 3921"> <!-- 3921 - Expedido - Rejeitado -->
    <h5>Motivo da Devolução</h5>
    <div class="card">
        <div class="card-body">
        <div class="row">
            <div class="col-12">
                <p *ngIf="aditivo?.motivoDevolucao">{{aditivo?.motivoDevolucao}}</p>
                <p *ngIf="!aditivo?.motivoDevolucao"><i>Motivo não informado</i></p>
            </div>
        </div>
        </div>
    </div>
</span>
